import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FeedbackFlagComponent } from './feedback-flag/feedback-flag.component';
import { FooterComponent } from './footer/footer.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HeaderNavComponent } from './header-nav/header-nav.component';
import { InfoIconComponent } from './info-icon/info-icon.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { CurrencyDropdownComponent } from './currency-dropdown/currency-dropdown.component';
import { FrequencyDropdownComponent } from './frequency-dropdown/frequency-dropdown.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { ActionBarComponent } from './action-bar/action-bar.component';
import { ButtonBarComponent } from './button-bar/button-bar.component';
import { SkuCountComponent } from './sku-count/sku-count.component';
import { GenericModalComponent } from './generic-modal/generic-modal.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { SystemErrorComponent } from './system-error/system-error.component';
import { DateRangeComponent } from './date-range/date-range.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ExtractionRowComponent } from './extraction-row/extraction-row.component';

@NgModule({
    imports: [
        FormsModule,
        RouterModule,
        CommonModule,
        RouterModule,
        MatMenuModule,
        MatTabsModule,
        MatTooltipModule,
        MatFormFieldModule,
        MatSelectModule,
        MatDialogModule,
        MatCheckboxModule,
        MatButtonModule,
        MatDatepickerModule,
        ReactiveFormsModule,
    ],
    declarations: [
        FeedbackFlagComponent,
        FooterComponent,
        PageNotFoundComponent,
        HeaderNavComponent,
        InfoIconComponent,
        LoadingSpinnerComponent,
        CurrencyDropdownComponent,
        FrequencyDropdownComponent,
        GenericModalComponent,
        SystemErrorComponent,
        DateRangeComponent,
        ProgressBarComponent,
        ActionBarComponent,
        ButtonBarComponent,
        SkuCountComponent,
        ExtractionRowComponent,
    ],
    providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }],
    exports: [
        FeedbackFlagComponent,
        FooterComponent,
        PageNotFoundComponent,
        HeaderNavComponent,
        InfoIconComponent,
        LoadingSpinnerComponent,
        ProgressBarComponent,
        ActionBarComponent,
        ButtonBarComponent,
        SkuCountComponent,
        CurrencyDropdownComponent,
        FrequencyDropdownComponent,
        GenericModalComponent,
        SystemErrorComponent,
        DateRangeComponent,
        ExtractionRowComponent,
    ],
})
export class SharedUiModule {}
